module.exports = __webpack_public_path__ + "static/media/ashokmarla.c3d89b0d.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/ashokmarla.webp
// module id = 287
// module chunks = 0